import ctl from '@netlify/classnames-template-literals'
import { AnimatePresence } from 'motion/react'
import { ReactNode } from 'react'
import { MagicSwirl } from '../magic-swirl'

export type GenericInputChildrenProps = {
	className?: string
	invisibleInputClassName?: string
	wrapperClassName?: string
}

export interface GenericInputProps {
	isGenerating?: boolean
	isLoading?: boolean
	isDisabled?: boolean
	isWaiting?: boolean
	isReadOnly?: boolean
	children: (props: GenericInputChildrenProps) => ReactNode
}

const inputWrapperClassName = ctl(`
	focus-within:ring-4 ring-blue-100 rounded-md w-full
	relative
	`)

export function GenericInput(
	{ isGenerating = false, isLoading = false, isDisabled = false, isWaiting = false, isReadOnly = false, children }:
		GenericInputProps,
) {
	const loadingMode = isGenerating || isLoading

	const inputClassName = ctl(`
		rounded-md ring-1 ring-grey-100 p-2 w-full 
		border-none border-transparent 
		focus:border-transparent 
		focus-visible:border-transparent
		focus:outline-none
		focus-visible:outline-none
		focus-visible:ring-blue-500
		placeholder:text-grey-500 placeholder:italic
		${isGenerating ? 'text-transparent cursor-wait bg-purple-50/50' : 'text-grey-800 bg-white'}
		 relative
		 transition-all 
		 ${isDisabled ? 'opacity-50' : ''}
		 ${isReadOnly ? 'cursor-not-allowed' : ''}
		 ${isWaiting ? 'opacity-50 cursor-wait' : ''}
		`)

	// You don't need both of these; the wrapper mode is if you have an invisible input
	const wrapperClassName = ctl(`
		rounded-md ring-1 ring-grey-100 p-2 w-full 
		focus-within:ring-blue-500
		placeholder:text-grey-500 placeholder:italic
		${isGenerating ? 'text-transparent cursor-wait bg-purple-50/50' : 'text-grey-800 bg-white'}
		 relative
		 transition-all 
	`)

	const invisibleInputClassName = ctl(`
		border-none border-transparent 
		focus:border-transparent 
		focus:outline-none
	`)

	return (
		<div className={inputWrapperClassName}>
			{children({ className: inputClassName, invisibleInputClassName, wrapperClassName })}
			{isGenerating
				? (
					<AnimatePresence>
						<MagicSwirl />
					</AnimatePresence>
				)
				: null}
		</div>
	)
}
